/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  FooterService,
  IFooterMethods,
  FeatureSectionService,
  IFeatureSectionMethods,
  StaticPageContentService,
  IStaticPageContentMethods,
  IFormatPolicyDetailMethods,
  FormatPolicyDetailService,
  IUpdatePayoutMethods,
  UpdatePayoutService,
  IButtonMethods,
  ButtonService,
  ISendReminderMethods,
  SendReminderService,
  FormatTimelineDetailService,
  IFormatTimelineDetailMethods,
  IBlockchainProofMethods,
  BlockchainProofService,
  IGetTransactionListMethods,
  GetTransactionListService
} from "./components";

export type PayoutDetailAgent = IHeaderMethods &
  IFeatureSectionMethods &
  IFooterMethods &
  IStaticPageContentMethods &
  IFormatPolicyDetailMethods &
  IUpdatePayoutMethods &
  IButtonMethods &
  ISendReminderMethods &
  IFormatTimelineDetailMethods &
  IBlockchainProofMethods &
  IGetTransactionListMethods; 

const getPlugins = () => {
  return [
    new HeaderService(),
    new FeatureSectionService(),
    new FooterService(),
    new StaticPageContentService(),
    new FormatPolicyDetailService(),
    new UpdatePayoutService(),
    new ButtonService(),
    new SendReminderService(),
    new FormatTimelineDetailService(),
    new BlockchainProofService(),
    new GetTransactionListService(),
  ];
};

export const getAgent = () => {
  return createAgent<PayoutDetailAgent>({
    plugins: getPlugins(),
  });
};
